module.exports = __webpack_public_path__ + "13d0d56fb4e15bbdffcab95f593460b9.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/spinner-load.gif
// module id = 668
// module chunks = 0